/* CWR 1.2 — floating bottom nav + FAB (mockup dashboard-mockup.html:1560–1622).
   Themed via the injected client tokens; clears the iOS home-indicator safe area. */

.navWrap {
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: calc(var(--tg-safe-area-inset-bottom, env(safe-area-inset-bottom, 0px)) + 14px);
  z-index: 60;
  display: flex;
  justify-content: center;
  pointer-events: none;
}

.bottomNav {
  position: relative;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1.2fr 1fr 1fr;
  align-items: center;
  padding: 10px 14px;
  border-radius: 9999px;
  background: var(--bottom-nav-bg, rgba(24, 22, 20, 0.72));
  backdrop-filter: var(--glass-blur, blur(22px) saturate(140%));
  box-shadow: var(--bottom-nav-shadow, 0 14px 40px rgba(0, 0, 0, 0.5));
  pointer-events: auto;
}

/* Same tapered amber ring as the home cards (mockup applies it to .bottom-nav).
   No overflow:hidden — the raised FAB must overflow upward; the mask draws only
   the 1px border edge so it never clips the FAB. */
.bottomNav::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  padding: 1px;
  background: var(--booking-card-ring-bg, linear-gradient(135deg, rgba(255, 181, 133, 0.16) 0%, rgba(255, 181, 133, 0.03) 100%));
  -webkit-mask: linear-gradient(black 0 0) content-box, linear-gradient(black 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
  z-index: 0;
}

.navItem {
  /* Button reset — no global button reset exists, and the global * reset paints
     background broadly; without this, default chrome can leak into the
     mockup-governed nav. */
  appearance: none;
  border: 0;
  background: transparent;
  font: inherit;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  position: relative;
  padding: 4px 0;
  color: var(--text-tertiary);
  transition: color 0.2s;
}

.navItem svg {
  width: 22px;
  height: 22px;
  stroke-width: 1.6;
}

.label {
  font-family: var(--client-font-body, 'Outfit', system-ui, sans-serif);
  font-size: 10.5px;
  font-weight: 500;
  letter-spacing: 0.005em;
}

.navItem.active {
  color: var(--accent, #e8954f);
}

.navItem.active::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 50%;
  transform: translateX(-50%);
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--accent, #e8954f);
  box-shadow: 0 0 10px rgba(var(--accent-rgb, 233, 122, 61), 0.7);
}

.fabSlot {
  display: grid;
  place-items: center;
}

.fab {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: var(--nav-fab-bg, linear-gradient(to bottom, #ffb07a 0%, #f0813a 50%, #c9501f 100%));
  color: var(--text-on-accent);
  display: grid;
  place-items: center;
  border: none;
  box-shadow: var(--nav-fab-shadow, 0 6px 18px rgba(152, 66, 16, 0.45));
  transition: transform 0.2s ease;
}

.fab:disabled {
  opacity: 0.5;
}

.fab:active {
  transform: scale(0.96);
}

.fab svg {
  width: 22px;
  height: 22px;
  stroke-width: 2.6;
}
